import { Box, Button, Typography } from "@mui/material";
import type { FC } from "react";

interface Props {
  readonly setOpenRequestDialog: (value: boolean) => void;
}

const B2bOption: FC<Props> = ({ setOpenRequestDialog }) => (
  <Box sx={{ textAlign: "center" }}>
    <Typography variant="body2" color="textSecondary">
      Nie masz konta B2B?{" "}
      <Button
        variant="text"
        color="primary"
        sx={{ fontWeight: 600, textTransform: "none" }}
        onClick={() => setOpenRequestDialog(true)}
      >
        Wyślij wniosek o dostęp
      </Button>
    </Typography>
  </Box>
);

export default B2bOption;
